






















































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';
import { date } from '@/filters/date';
import { MandateTypes, MandateStatus } from '../../../enum/mangoPay/MandateTypes';
import { BankAccountStateFilters } from '../../../enum/mangoPay/BankAccountTypes';

import ExporoTooltip from '@/components/_common/Tooltip.vue';
import ExporoMenu from '@/components/_common/Menu.vue';

interface AccountFilter {
  name: string,
  value: string,
}
@Component({
  name: 'bank-account-list-selector',
  filters: {
    date,
  },
  components: {
    ExporoTooltip,
    ExporoMenu,
  },
})
export default class BankAccountListSelector extends Vue {
  @Prop({ default: undefined }) bankAccounts?: Array<BankAccount>;
  @Prop({ default: {} }) mandates: MangoPayMandates;
  @Prop({ default: undefined }) selectedBankAccount?: String;
  @Prop({ default: false }) horizontal?: Boolean;

  @Emit()
  update(bankAccountId: string) {
    this.$emit('select', bankAccountId);
  }
  
  private visibilityOff: boolean = true;
  private accountFilter: AccountFilter = this.BankAccountStateFilters[0];
  
  get isFiltering() {
    return this.accountFilter.value !== BankAccountStateFilters.ALL;
  }

  get hasBankAccounts() {
    return this.bankAccounts && this.bankAccounts.length > 0;
  }

  get hasFilteredBankAccounts() {
    return this.filteredAccounts && this.filteredAccounts.length > 0;
  }

  get BankAccountStateFilters(){
    return Object.keys(BankAccountStateFilters).map(state => ({ 
        name: this.$t('forms.label', {context: BankAccountStateFilters[state]}),
        value: BankAccountStateFilters[state],
    }));
  }

  get filteredAccounts(){
    if(this.bankAccounts){
      return this.bankAccounts.filter( bankAccount => {
        if(this.accountFilter.value === BankAccountStateFilters.ALL){
          return bankAccount;
        }

        if(this.accountFilter.value === BankAccountStateFilters.ACTIVE){
          return bankAccount.Active;
        }

        if(this.accountFilter.value === BankAccountStateFilters.INACTIVE){
          return !bankAccount.Active;
        }

        return false;
      });
    }

    return [];
  }

  private hasMandate(bankAccountId: string) {
    return this.mandates[ bankAccountId ]?.Status === MandateStatus.ACTIVE ||
      this.mandates[ bankAccountId ]?.Status === MandateStatus.SUBMITTED;
  }

  /**
   * Shows only the first and last character of a string
   */
  private censorText(account: BankAccount) {
    const { IBAN } = account;
    var censored = this.$t('forms.placeholder', { context: 'IBANCensored', number: `${IBAN.slice(IBAN.length - 4, IBAN.length)}` });

    return this.visibilityOff ? censored : IBAN;
  }

  private onFilterUpdate(value) {
    this.accountFilter = value;
  }
}
